<div id="wrapper">

  <div class="page-title">
    <div class="tf-tsparticles">
      <div id="tsparticles1" data-color="#fff" data-line="#fff"></div>
    </div>
    <div class="tf-container">
      <div class="row">
        <div class="col-12">
          <div class="content">
            <h1 class="title">Page not found</h1>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<div class="spacing-big"></div>

<div class="tf-container">
  <div class="row">
    <div class="col">
      <div class="center">

        <h3>Sorry, we couldn’t find the page you were looking for.</h3>
        <h3>It may have been moved or deleted</h3>
        <div class="spacing-minor"></div>
        <button class="tf-btn style-1" (click)="redirectNow()">Return to home</button>

      </div>
    </div>
  </div>
</div>

<div class="spacing-big"></div>